import React, { useState } from "react";

import style from "./style.module.css";
import { useHistory } from "react-router-dom";
import { useAppDispatch as useDispatch } from "../../hooks/redux";

import { setEmail as setEmailRedux, setType } from "../../redux/actions/admin";
import LasMaterialApi from "../../api/lasMaterial";
import { Button } from "semantic-ui-react";
import Logo from "../../components/Logo/Logo";

export default function LasMaterialLoginPage({ match }: any) {
  // const [{ token }] = useCookies();
  const history = useHistory();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  
  const login = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await LasMaterialApi.login(match.params.hash, email.toLocaleLowerCase());
      //CHECK EMAIL dispacth no retorno da api
      dispatch(setEmailRedux(email));
      dispatch(setType("lasMaterial"));
      history.push(`/lasMaterialContract`);
    } catch (err) {
      setError("Link caducado");
      console.log(err);
    }
    setLoading(false);
  };

  return (
    <div className={style.page}>
      <div className={style.container}>
        <Logo />
        <div className="ui centered fluid card">
          <div className="content">
            {/* <div className="header">Smart Contract</div> */}
            <form className="ui form" onSubmit={login} method="post" action="">
              <div className="field">
                <label>Email</label>
                <input
                  type="text"
                  name="first-name"
                  placeholder="Indique su email"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                />
              </div>

              <Button loading={loading} className="ui button" type="submit">
                Accesar
              </Button>
            </form>
            <text className={style.error}>{error}</text>
          </div>
          <div className="content"></div>
        </div>
      </div>
    </div>
  );
}
